<template>
  <div>
    <template v-if="pattern=='model'">
      必填
      <Checkbox label="必填" v-model="content.must"></Checkbox>
      <Input style="width:100px" v-model="content.title" :disabled="$route.name!='approvalCreate'" placeholder="请输入标题"></Input>
    </template>
      <div style="display: inline-block;width:100px;text-align: right;vertical-align: top;" v-else>{{content.title}}<span style="color: red" v-if="content.must">*</span></div>
    ：
    <template v-if="pattern == 'submission' || pattern=='model'">
      <DatePicker type="date" :disabled="pattern != 'submission'" placeholder="请选择日期" @on-change="content.selected = $event" style="width: 200px"></DatePicker>
      <Icon class="close-icon" v-if="pattern=='model'" type="md-close-circle" @click="$emit('del',index)"></Icon>
    </template>
    <template v-else>
      <div style="display: inline-block">{{content.selected}}</div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "approvalDate",
    props:{
      index:Number,
      pattern:String,
      contentIn:Object,
    },
    data:function () {
      return{
        content:{
          title:'',
          selected:'',
          must:false,
          allowSubmission:false,
        },
      }
    },
    mounted:function () {
      if(this.contentIn.title!=undefined){
        this.content = this.contentIn
      }
    },
    watch:{
      content:{
        handler(){
          if(this.content.must!=true||!this.isEmpty(this.content.selected)){
            this.content.allowSubmission = true
          }else{
            this.content.allowSubmission = false
          }
          this.$emit('change',this.content)
        },
        deep:true,
        immediate:true,
      }
    }
  }
</script>